import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import NavigationBar from "./components/NavigationBar.jsx";
import Footer from "./components/Footer.jsx";
import HomePage from "./pages/HomePage.jsx";
import MeetingsPage from "./pages/MeetingPage.jsx";
import CoursesPage from "./pages/CoursesPage.jsx";
import CourseDetailsPage from "./pages/CourseDetailsPage";
import CourseContentPage from "./pages/CourseContentPage";
import {AuthProvider} from "./contexts/AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import BrandingSignInPage from "./pages/SigninPage";
import SignUp from "./pages/SignupPage.jsx";
import AboutPage from "./pages/AboutPage";
import OurMissionPage from "./pages/OurMissionPage";
import OurVisionPage from "./pages/OurVisionPage";
import LoadingScreen from "./components/LoadingScreen";
import {useEffect, useState} from "react";
import FounderMessage from "./pages/FounderMessage";
import WhenNavigate from "./components/WhenNavigate";
import InstructorsPage from "./pages/InstructorsPage";
import HistoryPage from "./pages/HistoryPage";
import ActivatePage from "./pages/ActivatePage";
import DashboardPage from "./pages/DashboardPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.jsx";
import Chatbot from "./components/Chatbot";
import BookStorePage from "./pages/BookStorePage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import {CartProvider} from "./contexts/CartContext";
import ContactUsPage from "./pages/ContactUsPage";
import {ToastContainer} from "react-toastify";
import MyCoursesPage from "./pages/MyCoursesPage";
import PersonalLearningDashboard from "./pages/PersonalLearningDashboard";
import PersonalLearningDetail from "./pages/PersonalLearningDetail";
import AccountSettings from "./pages/AccountSettings";
import StatisticsPage from "./pages/StatisticsPage";
import UserProgressAnalysisPage from "./pages/UserProgressAnalysisPage";
import InstructorRegistrationPage from "./pages/InstructorRegistrationPage";
import FAQPage from "./pages/FAQPage";

function App() {
    const [loading, setLoading] = useState(true);
    const [contentLoaded, setContentLoaded] = useState(false);

    useEffect(() => {
        // Minimum loading süresi (1 saniye)
        const minLoadingTime = 1000;
        const startTime = Date.now();

        // Sayfa içeriği yüklenme kontrolü
        const checkContentLoaded = () => {
            // DOM tamamen yüklendiğinde
            if (document.readyState === 'complete') {
                setContentLoaded(true);
            }
        };

        // İlk kontrol
        checkContentLoaded();

        // ReadyState değişikliklerini dinle
        document.addEventListener('readystatechange', checkContentLoaded);

        // Resimler ve diğer kaynaklar yüklendiğinde
        window.addEventListener('load', () => {
            setContentLoaded(true);
        });

        // Content yüklendiğinde loading'i kapat
        const handleLoadingComplete = () => {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, minLoadingTime - elapsedTime);

            setTimeout(() => {
                setLoading(false);
            }, remainingTime);
        };

        if (contentLoaded) {
            handleLoadingComplete();
        }

        // Maksimum 5 saniye loading süresi (fallback)
        const maxTimer = setTimeout(() => {
            setLoading(false);
        }, 5000);

        return () => {
            document.removeEventListener('readystatechange', checkContentLoaded);
            window.removeEventListener('load', checkContentLoaded);
            clearTimeout(maxTimer);
        };
    }, [contentLoaded]);

    if (loading) {
        return <LoadingScreen/>;
    }

    return (
        <>
            <AuthProvider>
                <CartProvider> {/* 🛒 CartContext burada */}
                    <Router>
                        <WhenNavigate/>
                        <NavigationBar/>
                        <Routes>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/meetings" element={<MeetingsPage/>}/>

                            <Route element={<ProtectedRoute/>}>
                                <Route path="/course-content/:courseId" element={<CourseContentPage/>}/>
                            </Route>

                            <Route path="/about" element={<AboutPage/>}/>
                            <Route path="/history" element={<HistoryPage/>}/>
                            <Route path="/our-mission" element={<OurMissionPage/>}/>
                            <Route path="/our-vision" element={<OurVisionPage/>}/>
                            <Route path="/course-details/:id" element={<CourseDetailsPage/>}/>
                            <Route path="/signin" element={<BrandingSignInPage/>}/>
                            <Route path="/signup" element={<SignUp/>}/>
                            <Route path="/founder-message" element={<FounderMessage/>}/>
                            <Route path="/courses" element={<CoursesPage/>}/>
                            <Route path="/instructors" element={<InstructorsPage/>}/>
                            <Route path="/activate" element={<ActivatePage/>}/>
                            <Route path="/dashboard" element={<DashboardPage/>}/>
                            <Route path="/reset-password" element={<ResetPasswordPage/>}/>
                            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>

                            {/* 🛒 Yeni sayfalar */}
                            <Route path="/books" element={<BookStorePage />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/payment" element={<CheckoutPage />} />
                            <Route path="/contact-us" element={<ContactUsPage />} />
                            <Route path="/my-courses" element={<MyCoursesPage />} />
                            <Route path="/account" element={<AccountSettings />} />
                            <Route path="/statistics" element={<StatisticsPage />} />
                            <Route path="/user-progress-analysis" element={<UserProgressAnalysisPage />} />
                            <Route path="/instructor-registration" element={<InstructorRegistrationPage />} />
                            <Route path="/faq" element={<FAQPage />} />

                            <Route path="*" element={<Navigate to="/" replace/>}/>
                            <Route path="/personal-learning" element={<PersonalLearningDashboard />} />
                            <Route path="/personal-learning/course/:courseId" element={<PersonalLearningDetail />} />

                        </Routes>
                        <Footer/>
                    </Router>
                    <Chatbot/>
                </CartProvider>
            </AuthProvider>
            <ToastContainer position="top-right" autoClose={2000} />

        </>
    );
}

export default App;
